/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  defaultDateFormat: 'DD-MM-YYYY',
  api_url: 'https://backend.atharplatform.com',
  api_img: 'https://backend.atharplatform.com',

  // api_url: 'http://127.0.0.1:8000',
  // api_img: 'http://127.0.0.1:8000',
  defaultLanguage: 'ar',
  defaultPageSize:20
};
